import {Injectable} from '@angular/core';
import {Observable, of} from "rxjs";
import {emptyOrder, IOrder, IOrderLine} from "@retail-data-factory/rdf-angular-types-api";
import {Presenter} from "../../../internal/presenter/presenter";

@Injectable({
  providedIn: 'root'
})
export class ApiOrdersService {
  /**
   * Корзина
   */
  _basket: IOrder = {...emptyOrder};
  get basket(): IOrder {
    return this._basket;
  }


  constructor(public presenter: Presenter) {
  }

  getOrders(): Observable<Array<object>> {
    return of([]);
  }

  getOrder(orderId: string): Observable<object> {
    return of({});
  }


  mapOrderFromService(item: object): IOrder {
    return {...emptyOrder};
  }

  mapOrderToService(order: IOrder): object {
    return {};
  }


  /**
   * Очистить корзину
   */
  clearBasket() {
    this._basket = {...emptyOrder,
    lines: []};
  }

  /**
   * Добавить товар в корзину с указанным количеством
   */
  addItemToBasket(item: IOrderLine) {
    //this.basket.lines = this.basket.lines.filter(t=>t.itemId!==item.itemId);
    if (this.basket.lines.length !== 0) {
      this.basket.lines = this.basket.lines.filter(t => t.itemId !== item.itemId);
      this.basket.lines.push(item);
    } else {
      this.basket.lines.push(item);
    }
    console.log(this.basket.lines);
  }

  /**
   * Удалить товар из корзины по коду
   * @param itemId код товара
   */
  removeItemFromBasket(itemId: string) {
    this.basket.lines = this.basket.lines.filter(t => t.itemId !== itemId);
  }

  /**
   * Увеличить у товара количество на 1. Если товара в корзине нет, то он добавиться
   * @param item
   */
  increaseItemCount(item: IOrderLine) {
    const basketItem = this.basket.lines.find(t => t.itemId === item.itemId);
    if (basketItem) {
      basketItem.quantity += 1;
      basketItem.amount = basketItem.price * basketItem.quantity;
      basketItem.amount = Math.round(basketItem.amount * 100) / 100;
      basketItem.amountVat = basketItem.price * basketItem.quantity * (1 - 1 / (1 + basketItem.vatAmount));
    } else {
      this.basket.lines.push({...item});
    }
  }

  /**
   * Уменьшает количество товара по коду 1. Если итоговое количество меньше или равно 0 - то товар удаляется из корзины
   * @param item
   */
  decreaseItemCount(item: IOrderLine) {
    const basketItem = this.basket.lines.find(t => t.itemId === item.itemId);
    if (basketItem) {
      basketItem.quantity -= 1;
      basketItem.amount = basketItem.price * basketItem.quantity;
      basketItem.amount = Math.round(basketItem.amount * 100) / 100;
      basketItem.amountVat = basketItem.price * basketItem.quantity * (1 - 1 / (1 + basketItem.vatAmount));
    }
    this.basket.lines = this.basket.lines.filter(t => t.quantity > 0);
  }

  saveCopyBasket(value: IOrder){
    this._basket = value;
  }


}
